import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import heroImg from "../assets/image.png";
import "./AreaPage.css";
import   ServiceShowcase from"../components/ServiceShowcase.jsx"
import { color } from "framer-motion";
import { Bold } from "lucide-react";

const AreaPage = () => {
  const { pathname } = useLocation();

  const getArea = () => {
    return pathname
      .replace("/mobile-repair-service-in-", "")
      .replace("/mobile-repair-service-in/", "")
      .split("/")[0];
  };

  const area = getArea();

  const areaName = area
    ? area.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Whitefield";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Helmet>
        <title>Mobile Repair Service in {areaName} | Servizy</title>
      </Helmet>

      <main className="area-page">

        {/* HERO */}
        <section
          className="hsr-hero"
          style={{ backgroundImage: `url(${heroImg})` }}
        >
          <div className="hsr-content fade-up">
            <h1>
              Mobile Repair Service in{" "}
              <span className="area-name">{areaName}</span>
            </h1>

            <p>Fast, Reliable & Affordable Doorstep Repair</p>

            <Link to="/login" className="cta-btn">
              Book Repair
            </Link>
          </div>
        </section>

      <section className="area-new fade-up">
  <div className="container">

    <h2 className="main-title">
      Mobile Repair Service in {areaName} – Fast, Reliable & Affordable
    </h2>

    <p className="intro">
      Looking for a trusted mobile repair service in <span className="area-name" style={{color: "black", fontWeight: "bold" }}>{areaName}</span> Servizy offers quick, professional, and cost-effective smartphone repair solutions right at your doorstep. Whether your phone has a cracked screen, battery issue, or software glitch, our expert technicians are ready to fix it efficiently.
    </p>

    <p className="intro">
      We understand how important your mobile device is in your daily life. That’s why we focus on providing same-day repair service, genuine spare parts, and transparent pricing.
    </p>

    {/* WHY */}
    <div className="why-box fade-up">
      <h3>Why Choose Our Mobile Repair Service in {areaName}?</h3>

      <div className="why-grid">
        <span>✔️ Certified & experienced technicians</span>
        <span>✔️ Doorstep mobile repair service</span>
        <span>✔️ Same-day service for most issues</span>
        <span>✔️ Affordable pricing with no hidden charges</span>
        <span>✔️ Use of high-quality spare parts</span>
        <span>✔️ Service available across all areas of {areaName}</span>
      </div>

      <p style={{ marginTop: "15px" }}>
        Our goal is to deliver a hassle-free repair experience with long-lasting results.
      </p>
    </div>

    {/* SERVICES */}
<div className="services-section">
  <h3 className="services-title">Our Mobile Repair Services</h3>

  <div className="services-grid">

    <div className="service-card">
      <div className="service-header">
        <span className="icon">📱</span>
        <h4>Screen Replacement</h4>
      </div>
      <p>
        Broken or cracked screen? We provide high-quality screen replacement with precision and care.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔋</span>
        <h4>Battery Replacement</h4>
      </div>
      <p>
        Battery draining fast? We replace it with a durable and genuine battery to restore performance.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔌</span>
        <h4>Charging Port Repair</h4>
      </div>
      <p>
        Facing charging issues? Our technicians can fix or replace faulty charging ports quickly.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">💧</span>
        <h4>Water Damage Repair</h4>
      </div>
      <p>
        Dropped your phone in water? We offer advanced diagnostics and recovery solutions.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">⚙️</span>
        <h4>Software & OS Issues</h4>
      </div>
      <p>
        From app crashes to system errors, we resolve all software-related problems efficiently.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔊</span>
        <h4>Speaker & Mic Repair</h4>
      </div>
      <p>
        Experiencing audio issues? We repair or replace speakers and microphones for clear sound.
      </p>
    </div>

  </div>
</div>

    {/* EXTRA CONTENT */}
   <div className="details-section">

  {/* DOORSTEP */}
  <div className="detail-card">
    <h3>🚀 Doorstep Mobile Repair in {areaName}</h3>
    <p>
      Skip the hassle of visiting a service center. Book our doorstep mobile repair service and get your phone fixed at your home or office. Our technician will arrive on time, diagnose the issue, and fix it on the spot.
    </p>
  </div>

  {/* PRICING */}
  <div className="detail-card">
    <h3>💰 Affordable Mobile Repair with Warranty</h3>
    <p>
      We offer competitive pricing without compromising on quality. All repairs come with a service warranty, ensuring complete peace of mind.
    </p>
  </div>

  {/* PROCESS */}
  <div className="detail-card">
    <h3>⚙️ How It Works</h3>
    <ul className="steps">
      <li>Book your service online or call us</li>
      <li>Choose your preferred time slot</li>
      <li>Technician visits your location</li>
      <li>Get your phone repaired instantly</li>
    </ul>
  </div>

  {/* FAQ */}
  <div className="detail-card">
    <h3>❓ FAQ – Mobile Repair Service in {areaName}</h3>

    <div className="faq-item">
      <strong>1. How long does mobile repair take?</strong>
      <p>Most repairs are completed within 30–60 minutes.</p>
    </div>

    <div className="faq-item">
      <strong>2. Do you provide doorstep service?</strong>
      <p>Yes, we offer doorstep service across all areas.</p>
    </div>

    <div className="faq-item">
      <strong>3. Is there any warranty?</strong>
      <p>Yes, we provide limited warranty.</p>
    </div>

    <div className="faq-item">
      <strong>4. What brands do you repair?</strong>
      <p>iPhone, Samsung, OnePlus, Xiaomi, Vivo, Oppo & more.</p>
    </div>

    <div className="faq-item">
      <strong>5. How much does mobile repair cost?</strong>
      <p>Depends on issue & model. Transparent pricing guaranteed.</p>
    </div>
  </div>

</div>

    {/* CTA */}
    <div className="cta-new fade-up">
      <h3>Get your smartphone fixed today with the best mobile repair service in {areaName}</h3>
      <p>📞 Book now with Servizy for fast, reliable, and affordable repairs!</p>
      <br/>
      <Link to="/login" className="cta-btn">Book Now</Link>
    </div>

  </div>
</section>
        <ServiceShowcase />

      </main>
    </>
  );
};

export default AreaPage;